import 'bootstrap/dist/css/bootstrap.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { authenticate } from './authProvider';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import * as account from './store/account.store';
import * as clientCommand from './store/client-command.store';


// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

const pollForClientCommands = () => {
    clientCommand.actionCreators.getClientCommand()(store.dispatch, store.getState);
}

authenticate(() => {
    ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>,
        document.getElementById('root'));

    account.actionCreators.submitAccount()(store.dispatch, store.getState);
    setInterval(pollForClientCommands, 7200000); // Every two hours 7200000 (1 hour = 3,600,000 ms)
    registerServiceWorker();
});
